import { useStaticQuery, graphql } from "gatsby";

const query = graphql`
    query AllAnimalExhibits {
        allDatoCmsAnimalExhibit {
            edges {
                node {
                    ...AnimalExhibitFields
                }
            }
        }
    }
`;

export const useAllAnimalExhibits = (): Queries.AnimalExhibitFieldsFragment[] => {
    
        const data = useStaticQuery<Queries.AllAnimalExhibitsQuery>(query);

        return data.allDatoCmsAnimalExhibit.edges.map(
            ({ node: animalExhibit }) => {
                return animalExhibit as Queries.AnimalExhibitFieldsFragment;
            }
        );
    };